import { createSlice } from '@reduxjs/toolkit';

export const LockAlarmListSlice = createSlice({
    name: 'LockAlarmList',
    initialState: {
        loading: false,
        data: {

        },
         alarm_master: {

        },
        error: false,
    },
    reducers: {
        LOCK_ALARM_FETCH_START: (state) => {
            state.loading = true
        },
        LOCK_ALARM_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
        },
        LOCK_ALARM_MASTER_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.alarm_master = action.payload
        },
        LOCK_ALARM_FETCH_ERROR: (state) => {
            state.error = true
        }
    }
});

export const {LOCK_ALARM_MASTER_FETCH_SUCCESS, LOCK_ALARM_FETCH_START, LOCK_ALARM_FETCH_SUCCESS, LOCK_ALARM_FETCH_ERROR } = LockAlarmListSlice.actions;
export default LockAlarmListSlice.reducer;